export const dialogPaperSx = { borderRadius: 2 };

export const dialogTitleSx = {
  px: { xs: 2, sm: 3 },
  pt: { xs: 2, sm: 2.5 },
  pb: 1,
  color: "text.primary",
  fontSize: "1.25rem",
  fontWeight: 700,
  lineHeight: 1.35,
};

export const dialogActionsSx = {
  px: { xs: 2, sm: 3 },
  pb: { xs: 2, sm: 2.5 },
  pt: 0,
  gap: 1,
  flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "stretch", sm: "center" },
  "& > :not(style) ~ :not(style)": { ml: 0 },
};
